import tombstoneStore from '../store/Store';
import * as ctqNames from './ctqNames';
import { logVerboseUsage } from 'owa-analytics';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Add each instanceKeys in the given list to the tombstones map
 * @param instanceKeys - the instanceKeys to be added to the tombstones map
 * @param folderId for these instanceKeys
 * @param removeFromTombstoneCondition - the condition for removing from tombstone
 * @param state which contains the tombstoneStore
 */
export var add = action('tombstoneOperations.add')(select({
    store: function () { return tombstoneStore; },
})(function add(instanceKeys, folderId, removeFromTombstoneCondition, state) {
    // Create the tombstone map for the folder if it doesn't exist
    var folderTombstoneMap = state.store.folderTombstoneMap;
    if (!(folderId in folderTombstoneMap)) {
        folderTombstoneMap[folderId] = {};
    }
    // Add to tombstone list
    var tombstoneMap = folderTombstoneMap[folderId];
    instanceKeys.forEach(function (instanceKey) {
        // If a tombstone entry doesn't exist for this row, or existing tombstone condition type is not on delete notification,
        // override the condition with latest unless it's a delete tombstone, which overrides other types.
        // If a row is removed and pending delete, no row modified operation should bring it back.
        var existingRemoveCondition = tombstoneMap[instanceKey];
        if (!existingRemoveCondition ||
            existingRemoveCondition.type !=
                0 /* OnDeleteNotification */) {
            tombstoneMap[instanceKey] = removeFromTombstoneCondition;
        }
    });
    logVerboseUsage(ctqNames.AddToTombstoneCTQName, [
        Object.keys(folderTombstoneMap[folderId]).length,
    ]);
}));
/**
 * Remove given instanceKey from the tombstones map if it exists
 * @param instanceKey - the instanceKey to remove
 * @param folderId for these instanceKeys
 * @param state which contains the tombstoneStore
 */
export var remove = action('tombstoneOperations.remove')(select({
    store: function () { return tombstoneStore; },
})(function remove(instanceKey, folderId, state) {
    // Tombstone list doesn't exist for this folder. We may have never deleted in this folder
    var folderTombstoneMap = state.store.folderTombstoneMap;
    if (!(folderId in folderTombstoneMap)) {
        return;
    }
    var tombstoneMap = folderTombstoneMap[folderId];
    delete tombstoneMap[instanceKey];
    logVerboseUsage(ctqNames.RemoveFromTombstoneCTQName, [
        Object.keys(folderTombstoneMap[folderId]).length,
    ]);
}));
/**
 * Removes all instanceKeys from the tombstones map
 * @param state which contains the tombstoneStore
 */
export var removeAll = action('tombstoneOperations.removeAll')(select({
    store: function () { return tombstoneStore; },
})(function removeAll(state) {
    // Remove all by reinitializing entire folderTombstoneMap
    state.store.folderTombstoneMap = {};
    logVerboseUsage(ctqNames.RemoveAllFromTombstoneCTQName);
}));
/**
 * Returns flag indicating whether the given instanceKey for folderId is contained in tombstone map
 * @param instanceKey - the instanceKey to check
 * @param folderId for the instanceKey
 * @param state which contains the tombstoneStore
 * @returns the RemoveFromTombstoneCondition if it exists, undefined otherwise
 */
export var contains = select({
    store: function () { return tombstoneStore; },
})(function contains(instanceKey, folderId, state) {
    var folderTombstoneMap = state.store.folderTombstoneMap;
    if (folderId in folderTombstoneMap) {
        return folderTombstoneMap[folderId][instanceKey];
    }
    return undefined;
});
/**
 * Clear all instanceKeys for the given folderId from tombstone map
 * @param folderId for these instanceKeys
 * @param state which contains the tombstoneStore
 */
export var clearMapForFolder = action('tombstoneOperations.clearMapForFolder')(select({
    store: function () { return tombstoneStore; },
})(function clearMapForFolder(folderId, state) {
    // Delete the map for the folder
    var folderTombstoneMap = state.store.folderTombstoneMap;
    if (folderTombstoneMap[folderId]) {
        logVerboseUsage(ctqNames.ClearTombstoneForFolderCTQName, [
            Object.keys(folderTombstoneMap[folderId]).length,
        ]);
        delete folderTombstoneMap[folderId];
    }
}));
//# sourceMappingURL=tombstoneOperations.js.map